export default "__VITE_ASSET__6acffeda__"